module.exports = __webpack_public_path__ + "static/media/sem_dados_processo.34c99ff5.svg";